import axios from "axios"
import cloudFunctionsURL, { dataRoomURL } from "../config/cloudFunctionsURL"

const api = axios.create({
  baseURL: cloudFunctionsURL(),
})

export const dataRoomApi = axios.create({
  baseURL: dataRoomURL(),
})

export function setAuthToken(token) {
  api.defaults.headers.common["Authorization"] = token
  dataRoomApi.defaults.headers.common["Authorization"] = token
}

const handleErrorResponse = (error) => {
  if (error.response) {
    console.error(
      `API Error: ${error.response.status}`,
      error.response.data
    )
    if (error.response.status === 401) {
      window.location.href = "/"
    }
  }
  return Promise.reject(error)
}

api.interceptors.response.use((response) => response, handleErrorResponse)
dataRoomApi.interceptors.response.use((response) => response, handleErrorResponse)

export default api
